import { ActivityServiceEvent } from "@netent/origin";
import { IPlayUIState } from "@netent/playui";
import { ListenerCreator } from "../../types";

const slow = () => (): IPlayUIState => ({
  activityIndicator: {
    enabled: true
  }
});

const normal = () => (): IPlayUIState => ({
  activityIndicator: {
    enabled: false
  }
});

export const listeners = new Map<ActivityServiceEvent, ListenerCreator>([
  ["slow", slow],
  ["normal", normal]
]);
